/* -----------------Globals--------------- */
import { router, useLocalSearchParams } from "expo-router";
import { useState } from "react";

import { proethicaOnboardingConfig } from "@constants/demo/praxis-proethica";
import { useSession } from "@features/session";
import { useDemoExamStore } from "@hooks/useDemoExamStore";
import { useGlobalStore } from "@hooks/useGlobalStore";
import { ChooseCategoryContainer } from "../screens/ChooseCategoryContainer";
/* -----------------Child components--------------- */
import ChooseDateContainer from "../screens/ChooseDateContainer";
import { ChooseExamContainer } from "../screens/ChooseExamContainer";
import { RedeemContainer } from "../screens/RedeemContainer";
import ProethicaOnboardingFlow from "./ProethicaOnboardingFlow";

/* -----------------UI--------------- */
import { Box } from "@memorang/ui";

const OnboardingRouteContainer = () => {
	const searchParams = useLocalSearchParams();
	const demoExamId = useDemoExamStore((state) => state.currentExam.id);
	const setHasCompletedProethicaOnboarding = useGlobalStore(
		(state) => state.setHasCompletedProethicaOnboarding,
	);
	const { handleCreateFormativeSession } = useSession();
	const [proethicaStepIndex, setProethicaStepIndex] = useState(0);

	const step = (searchParams?.step || "category") as string;
	const handleUpdateParam = (newStep: string) => {
		router.setParams({
			step: newStep,
		});
	};

	const comps: Record<string, React.ReactNode> = {
		chooseexam: <ChooseExamContainer handleNext={handleUpdateParam} />,
		userdetails: <ChooseDateContainer />,
		redeem: (
			<RedeemContainer
				handleNext={() => {
					handleUpdateParam("category");
				}}
			/>
		),
		category: <ChooseCategoryContainer />,
	};

	if (demoExamId === "proethica" && proethicaOnboardingConfig.enabled) {
		const handleStartModuleOne = () => {
			setHasCompletedProethicaOnboarding(true);
			const moduleId = proethicaOnboardingConfig.startModuleId;

			if (!moduleId) {
				router.push("/modules");
				return;
			}

			handleCreateFormativeSession({
				dist: { low: 0, medium: 0, high: 0, none: 10 },
				tags: [Number(moduleId)],
				itemIds: [],
				push: true,
			});
		};

		return (
			<ProethicaOnboardingFlow
				config={proethicaOnboardingConfig}
				activeStepIndex={proethicaStepIndex}
				onStepChange={setProethicaStepIndex}
				onStartModuleOne={handleStartModuleOne}
			/>
		);
	}

	return <Box flex={1}>{comps[step]}</Box>;
};

export default OnboardingRouteContainer;
